import { createContext } from "react";

export interface AnonymousSessionContextValue {
  isAnonymous: boolean;
  entityId: string;
  isInitialized: boolean;
  hasSession: boolean;
  createSession: () => Promise<boolean>;
}

// Returned by useAnonymousSession() when no provider is mounted (i.e. the
// current route is not anonymous-allowed) and by the provider itself when the
// user is authenticated. Shape must match so consumers behave identically in
// both cases.
export const ANONYMOUS_SESSION_FALLBACK: AnonymousSessionContextValue = {
  isAnonymous: false,
  entityId: "",
  isInitialized: true,
  hasSession: true,
  createSession: async () => false,
};

export const AnonymousSessionContext =
  createContext<AnonymousSessionContextValue | null>(null);
